module.exports = __webpack_public_path__ + "static/media/add.5d86fa91.svg";